import {
    RESET_GAME_ACTION,
    ADD_POINT_ACTION,
    ADD_WORD_ACTION,
    REMOVE_WORD_ACTION,
    ENTER_COLLECTING_MODE_ACTION,
    ENTER_IDLE_MODE_ACTION,
    ENTER_ANSWERING_MODE_ACTION,
    ENTER_EDITING_MODE_ACTION,
    COLLECT_LETTER_ACTION,
    CHECK_ANSWER_ACTION,
    MARK_WORD_AS_FOUND_ACTION,
    SET_LETTERS_ACTION,
    MARK_LETTERS_AS_USED_ACTION,
    REQUEST_CONFIRMATION_ACTION,
    CANCEL_CONFIRMATION_ACTION,
    ENTER_GAME_COMPLETE_ACTION,
    ENTER_GAME_TIME_UP_ACTION,
} from '../constants';

export const resetGame = () => {
    return {
        type: RESET_GAME_ACTION,
    };
};

export const addPoint = () => {
    return {
        type: ADD_POINT_ACTION,
    };
};

export const addWord = (newWord) => {
    return {
        type: ADD_WORD_ACTION,
        newWord: newWord,
    };
};

export const removeWord = (index) => {
    return {
        type: REMOVE_WORD_ACTION,
        index: index,
    };
};

export const enterCollectingMode = () => {
    return {
        type: ENTER_COLLECTING_MODE_ACTION,
    };
};

export const enterIdleMode = () => {
    return {
        type: ENTER_IDLE_MODE_ACTION,
    };
};

export const enterAnsweringMode = () => {
    return {
        type: ENTER_ANSWERING_MODE_ACTION,
    };
};

export const enterGameCompletedMode = () => {
    return {
        type: ENTER_GAME_COMPLETE_ACTION,
    };
};

export const enterGameTimeUpMode = () => {
    return {
        type: ENTER_GAME_TIME_UP_ACTION,
    };
};

export const enterEditingMode = () => {
    return {
        type: ENTER_EDITING_MODE_ACTION,
    };
};

export const collectLetter = (letter) => {
    return {
        type: COLLECT_LETTER_ACTION,
        letter,
    };
};

export const checkAnswer = (question, answer) => {
    return {
        type: CHECK_ANSWER_ACTION,
        question,
        answer,
    };
};

export const markWordAsFound = (word, color) => {
    return {
        type: MARK_WORD_AS_FOUND_ACTION,
        word,
        color,
    };
};

export const setLetters = (letters) => {
    return {
        type: SET_LETTERS_ACTION,
        letters,
    };
};

export const markLettersAsUsed = (letterIds) => {
    return {
        type: MARK_LETTERS_AS_USED_ACTION,
        letterIds,
    };
};

export const createConfirmAction = ({pendingConfirmationAction, msg, pendingConfirmationCallback}) => {
    return {
        type: REQUEST_CONFIRMATION_ACTION,
        pendingConfirmationAction,
        msg,
        pendingConfirmationCallback,
    };
};

export const cancelConfirmation = () => {
    return {
        type: CANCEL_CONFIRMATION_ACTION,
    };
};

export const confirmPendingAction = () => {
    return (dispatch, getState) => {
        const cancelConfirmationAction = cancelConfirmation();
        if (getState().pendingConfirmation) {
            const pendingConfirmAction = getState().pendingConfirmation.pendingConfirmationAction;
            const pendingConfirmCallback = getState().pendingConfirmation.pendingConfirmationCallback;
            dispatch(pendingConfirmAction);
            // If there is a pending confirmation callback, call it
            if (pendingConfirmCallback && typeof pendingConfirmCallback === 'function') {
                pendingConfirmCallback();
            }
            dispatch(cancelConfirmationAction);
        } else {
            dispatch(cancelConfirmationAction);
        }
    };
};
